"use client";

import { RequireAuth } from "@/components/auth/AuthGuards";
import BiddingCarousel from "@/components/listing-carousels/BiddingCarousel";
import SavedListingCarousel from "@/components/listing-carousels/SavedListingCarousel";

/**
 * Client component that conditionally renders carousels for authenticated users
 * Uses RequireAuth guard component to handle authentication state
 */
export default function AuthenticatedCarousels() {
  return (
    <RequireAuth fallback={null}>
      <SavedListingCarousel />
      <BiddingCarousel />
    </RequireAuth>
  );
}
